import React, { useState } from 'react';
import { IconButton, MenuItem, Menu } from '@mui/material';
import { MoreVIcon } from 'tt-ui-lib/icons';
import styles from './CalcMenuButton.module.scss';

const options = ['Download'];

const CalcMenuButton = ({ params }) => {
  const { menuList, onMenuClick } = params;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClickButton = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (event, option) => {
    setAnchorEl(null);
    onMenuClick(option);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton className={styles.menuButton} onClick={handleClickButton}>
        <MoreVIcon style={{ width: 20, height: 20, flexShrink: 0, fontSize: 20 }} />
      </IconButton>
      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'lock-button',
          role: 'listbox',
        }}
      >
        {(menuList ?? options).map((option) => (
          <MenuItem
            key={option}
            // disabled={index === 0}
            // selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, option)}
          >
            {option}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default CalcMenuButton;
